import * as React from "react";
import { Alert, Button } from "antd";
import { store } from "../../../../store";
import { cloneDeep, get } from "lodash";
import { firewallRequirementsForVolumes } from "../../../../schema/types/workload/entity";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { v4 as uuidv4 } from "uuid";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

interface Props {
  index: number;
}
export const VolumeFirewallRecommendations: React.FC<Props> = ({ index }) => {
  const { id } = useCpFormContext();
  // TODO can also add a suggestion section to validator and move this there

  const volumes = useCpFormValue(`containers.${index}.volumes`);
  const isPublic = useCpFormValue(`firewallConfig.external.outbound.public`);
  const hostnames = useCpFormValue(`firewallConfig.external.outbound.allowHostname`);

  const firewallRecommendations: string[] = React.useMemo(() => {
    const form = store.getState().form.instances[id];
    const values = form.values;

    const firewallRecommendations: string[] = [];

    const isPublic = get(values, `firewallConfig.external.outbound.public`);
    const hostnames = get(values, `firewallConfig.external.outbound.allowHostname`);

    if (isPublic) {
      return firewallRecommendations;
    }

    const volumes = get(values, `containers.${index}.volumes`);
    for (const volume of volumes) {
      if (!volume) {
        continue;
      }
      for (const prefix of Object.keys(firewallRequirementsForVolumes)) {
        if (volume.uriType !== prefix) {
          continue;
        }

        const value: string[] = firewallRequirementsForVolumes[prefix];
        for (const recommendation of value) {
          if (!firewallRecommendations.includes(recommendation) && !hostnames.some((h) => h.value === recommendation)) {
            firewallRecommendations.push(recommendation);
          }
        }
      }
    }

    return firewallRecommendations;
  }, [volumes, isPublic, hostnames]);

  if (firewallRecommendations.length < 1) {
    return null;
  }

  return (
    <Alert
      className="my-4"
      description={
        <div>
          <div className="mb-2">
            Cloud volumes require outbound access to cloud provider hostnames. You can either allow access to specific
            cloud hostnames, or open outbound access to all destinations. Note that allowing only specific hostnames
            will restrict mutual TLS connections to workloads within other GVCs.
          </div>
          <ul className="flex flex-col gap-1 pl-4">
            {firewallRecommendations.map((r) => (
              <li className="list-disc">{r}</li>
            ))}
          </ul>
          <Button
            htmlType={`button`}
            className="mt-4"
            size={"small"}
            type={"primary"}
            onClick={() => {
              const form = store.getState().form.instances[id];
              const values = form.values;
              const hostnames = get(values, `firewallConfig.external.outbound.allowHostname`);
              const _hostnames = cloneDeep(hostnames);
              for (const recommendation of firewallRecommendations) {
                _hostnames.push({ id: uuidv4(), value: recommendation });
              }
              formSetValue(id, `firewallConfig.external.outbound.allowHostname`, _hostnames);
            }}
          >
            Allow Access Only To Cloud Hostnames
          </Button>
        </div>
      }
      type={"warning"}
    />
  );
};
